import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
// component, hooks
import NormalDisplay from "../../../../../../common/components/resultDisplay/NormalDisplay";
import BlankDisplay, {
  MESSAGE_TYPE,
} from "../../../../../../common/components/resultDisplay/BlankDisplay";
// store
import { StoreContext } from "../../../../../../store/StoreProvider";
import Act from "../../../../../../store/actions";
// config,utils
import { getLimitOffset } from "../helper";
import searchImage from "../../../../../../../images/search.jpg";

// style

const BasicTable = ({ headers, rows, dataChangeSignal }) => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { snaDisplay, diaryInfo } = sna;
  const { focusNodes } = snaDisplay || {};
  const { currentPage, pages, startSearch } = diaryInfo;
  // local state
  // hooks

  // 依據個別欄位分別取的要標註的 keyword
  const getKeyword = (row, header) => {
    const { content, evtStartPos = 0, evtEndPos = 0 } = row;
    const { id, name, label } = header;
    if (id === "content") {
      if (!content) return "";
      return content.substring(
        Number.parseInt(evtStartPos, 10),
        Number.parseInt(evtEndPos, 10)
      );
    }
    if (id === "persons") {
      // 可以標記多個人物
      // return ["蔡培火","林階堂"];
      return focusNodes.map((o) => o.id);
    }
    return "";
  };

  return (
    <Box mt={0} mb={3}>
      <Grid item>
        {/* 搜尋中說明 */}
        {startSearch && !rows && (
          <BlankDisplay
            messageType={MESSAGE_TYPE.searching}
            searchImage={searchImage}
          />
        )}
        {/* 若有不同型式的表格, 這裡可以切換 */}
        {Array.isArray(rows) && (
          <NormalDisplay
            tableContainerClassName="sna__diaryInfo--table"
            curResult={rows}
            headers={headers}
            getKeyword={getKeyword}
            dataChangeSignal={dataChangeSignal}
            // markStyle={markStyle}
            fontSize="0.875rem"
            forceResetPage={false}
            dataUniqKey="eventTypeTag"
            page={
              // component 的 page 會從 0 開始, 所以必須再 -1
              currentPage <= 0 ? currentPage : currentPage - 1
            }
            // rowsPerPage={rowsPerPage}
            onPageChange={(pageVal, _rowsPerPage) => {
              // component 的 page 會從 0 開始, 所以必須再 +1
              dispatch({
                type: Act.SNA_DIARY_INFO_CUR_PAGE,
                payload: pageVal + 1,
              });
              const { limit, offset } = getLimitOffset(
                pageVal + 1,
                _rowsPerPage || pages.rowsPerPage
              );

              dispatch({
                type: Act.SNA_DIARY_INFO_PAGES,
                payload: {
                  rowsPerPage: _rowsPerPage || pages.rowsPerPage,
                  limit,
                  offset,
                },
              });
            }}
            onRowsPerPageChange={(val) => {
              const { limit, offset } = getLimitOffset(1, val);
              dispatch({
                type: Act.SNA_DIARY_INFO_PAGES,
                payload: {
                  rowsPerPage: val,
                  limit,
                  offset,
                },
              });
            }}
            onCurPageRowsChange={(_rows) => {
              dispatch({
                type: Act.SNA_DIARY_INFO_CUR_PAGE_ROWS,
                payload: _rows,
              });
            }}
          />
        )}
      </Grid>
    </Box>
  );
};

BasicTable.propTypes = {
  headers: PropTypes.objectOf(PropTypes.any),
  rows: PropTypes.arrayOf(PropTypes.any),
  dataChangeSignal: PropTypes.string,
};

BasicTable.defaultProps = {
  headers: {},
  rows: [],
  dataChangeSignal: undefined,
};

export default BasicTable;
